import React from 'react';
import PropTypes from 'prop-types';
import { reduxFormPropTypes } from 'constants/propTypes';

import Switch from './Switch';

function FormSwitch(props) {
  const { input, meta, className, disabled, children } = props;
  const { name, value } = input;
  const { form } = meta;
  const fieldName = `${form}.${name}`;

  return (
    <Switch className={className} inputProps={input} name={fieldName} checked={!!value} disabled={disabled}>
      {children}
    </Switch>
  );
}

FormSwitch.defaultProps = {
  className: '',
  disabled: false,
};

FormSwitch.propTypes = {
  ...reduxFormPropTypes.field,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.func,
};

export default FormSwitch;
